/**
 * MessageCtaButton — the canonical Message CTA for other-user
 * Profile Detail.
 *
 * Per §42 / §43 of the Bucket-B briefing:
 *   - CTA exists, is available under the correct frontend/profile
 *     conditions, invokes the real chat-opening client seam.
 *   - DIRECT_CHAT_UI = DELIVERED (this ACT).
 *   - DIRECT_CHAT_BACKEND_POLICY = PENDING_BUCKET_C (the backend
 *     `chat_ready.HasAcceptedPair` gate is preserved untouched in
 *     this ACT; Bucket C removes it).
 *
 * The button is a real <button type="button"> with explicit type
 * (per React form guidance and §48 of the briefing).
 */

export interface MessageCtaButtonProps {
  readonly onClick: () => void;
  readonly disabled: boolean;
  readonly label?: string;
}

export function MessageCtaButton(props: MessageCtaButtonProps): React.ReactNode {
  const label = props.label ?? 'Сообщение';
  return (
    <button
      type="button"
      className="pd-message-cta"
      onClick={props.onClick}
      disabled={props.disabled}
      data-testid="profile-detail-message-cta"
    >
      {label}
    </button>
  );
}